import { faTimes } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useContext, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { MessageContext } from "../../../../common/message";
import { cleanJoin, cutShort } from "../../../../utils/stringUtil";
import { UPLOAD_STATUS } from "./DocumentUpload";
import Box from "../../../../common/box/Box";

function DocumentUploadProgress({ doc, dispatchUpdateAction }) {
  const message = useContext(MessageContext);
  const [displayProgress, setDisplayProgress] = useState(false);
  const [displayRemoveAttachment, setDisplayRemoveAttachment] = useState(false);
  const { t } = useTranslation();

  useEffect(() => {
    setDisplayProgress(
      doc.uploadStatus === UPLOAD_STATUS.IN_PROGRESS || doc.uploadStatus === UPLOAD_STATUS.ERROR
    );
    setDisplayRemoveAttachment(doc.uploadStatus === UPLOAD_STATUS.SUCCESS);
  }, [doc.uploadStatus]);

  return (
    <Box
      isBorderless={true}
      defaultPadding={false}
      className={cleanJoin(
        "has-text-weight-bold",
        displayRemoveAttachment ? "p-2 has-background-white-ter" : "p-0",
        doc.uploadStatus === UPLOAD_STATUS.NOT_STARTED ? "is-hidden" : ""
      )}
    >
      {doc.uploadStatus !== UPLOAD_STATUS.NOT_STARTED && (
        <a
          className="is-link has-text-grey-dark"
          rel="noopener noreferrer"
          href={doc.href}
          target="_blank"
        >
          {cutShort(doc.file.name, 40, "...")}
        </a>
      )}
      {displayRemoveAttachment && (
        <FontAwesomeIcon
          onClick={() => {
            message.toggle({
              title: t("requests.submission.upload.deleteAttachmentMessageTitle"),
              content: t("requests.submission.upload.deleteAttachmentMessage"),
              onNo: () => message.toggle({}),
              onYes: () => {
                doc.uploadStatus = UPLOAD_STATUS.NOT_STARTED;
                doc.uploadError = null;
                doc.uploadProgress = 0;
                doc.file = null;
                doc.href = null;

                dispatchUpdateAction();

                message.toggle({});
              },
            });
          }}
          className="is-pulled-right mt-1 ml-4 is-clickable"
          icon={faTimes}
          title={t("requests.submission.upload.deleteAttachment")}
        />
      )}
      {displayProgress && <progress className="ml-2" value={doc.uploadProgress} max="100" />}
    </Box>
  );
}

export default DocumentUploadProgress;
